import { useEffect, useRef, useState } from "react";

// 阿里云验证码
export const useAliyunCaptcha = () => {
  // 阿里云验证码实例
  const aliyunCaptchaObjRef = useRef();
  // 验证码验证是否通过
  const aliyunCaptchaResultRef = useRef(true);
  // 验证码结果
  const [aliyunCaptchaCode, setAliyunCaptchaCode] = useState();
  // 验证码错误结果
  const [aliyunCaptchaErrorCode, setAliyunCaptchaErrorCode] = useState();

  // 重置验证码结果
  const resetAliyunCaptchaCode = () => {
    setAliyunCaptchaCode(undefined);
    aliyunCaptchaObjRef.current?.destroyCaptcha();
    aliyunCaptchaObjRef.current = undefined;
  };

  // 手动触发验证码
  function triggerAliyunVerify (captchaResult = true) {
    // 控制是否重新验证
    aliyunCaptchaResultRef.current = captchaResult;
    // 初始化验证码
    aliyunCaptchaInit();
  }

  // 验证码初始化
  async function aliyunCaptchaInit () {
    try {
      window.initAliyunCaptcha({
        SceneId: "7dmqqchq8", // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: "xxslmpl", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#captcha-button", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 320,
          height: 40
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        region: "sgp",
        language: "cn" // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    } catch (error) {
      // 加载异常
      setAliyunCaptchaErrorCode("aliyunError");
    }
  }

  // 绑定验证码实例函数。该函数为固定写法，无需修改
  function getInstance (instance) {
    if (instance && !aliyunCaptchaObjRef.current) {
      aliyunCaptchaObjRef.current = instance;
      handleSimulatedClick("captcha-button");
    }
  }

  // 业务请求(带验证码校验)回调函数
  /**
   * @name captchaVerifyCallback
   * @function
   * 请求参数：由验证码脚本回调的验证参数，不需要做任何处理，直接传给服务端即可
   * @params {string} captchaVerifyParam
   * 返回参数：字段名固定，captchaResult为必选；如无业务验证场景时，bizResult为可选
   * @returns {{captchaResult: boolean, bizResult?: boolean|undefined}}
   */
  async function captchaVerifyCallback (captchaVerifyParam) {
    const aliyunCaptchaResult = aliyunCaptchaResultRef.current;

    if (aliyunCaptchaResult) {
      setAliyunCaptchaCode(captchaVerifyParam);
    } else {
      // 下次不再重新验证
      aliyunCaptchaResultRef.current = true;
    }

    // 构造标准返回参数
    const verifyResult = {
      captchaResult: aliyunCaptchaResult, // 验证码验证是否通过，boolean类型，必选
      bizResult: aliyunCaptchaResult
    };

    return verifyResult;
  }

  // 业务请求验证结果回调函数
  function onBizResultCallback () {
  }

  // 触发模拟点击元素
  function handleSimulatedClick (elementId) {
    // 获取你想要模拟点击的元素
    const element = document.getElementById(elementId);
    // 创建一个点击事件
    const clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: false,
      cancelable: true
    });
    // 触发点击事件
    element?.dispatchEvent(clickEvent);
  }

  return {
    aliyunCaptchaCode,
    aliyunCaptchaErrorCode,
    resetAliyunCaptchaCode,
    triggerAliyunVerify
  };
};
